NtechApp.ChatMessagesForm = function($view) {
    var me = this;

    this._$view = null;

    this._ajax = null;
    this._click = null;

    this._chatControls = null;
    this._chatMembers = null;
    this._messagesList = null;

    this._closeFormTimeout = null;

    this._openedChatId = null;

    this._construct = function() {
        me._$view = $view;

        me._ajax = new NtechApp.Ajax();
        me._click = new NtechApp.TouchClickEvent();

        me.showNoMessagesForm();

        me._chatControls = new NtechApp.ChatControls(me._$view, me);
        me._chatMembers = new NtechApp.ChatMembers(me._$view, me);
        me._messagesList = new NtechApp.MessagesList(
            me._$view.find(".chatMessages"), me, me._chatControls, me._chatMembers
        );

        me._chatControls.setMessagesList(me._messagesList);

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-closeMobileChatWindow]", function(event) {
            if(me.isFormOpened())
                me.closeForm();
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ChatMessagesForm.EVENT_ON_NEW_MESSAGE_CREATE = "NtechApp.ChatMessagesForm.EventOnNewMessageCreate";
NtechApp.ChatMessagesForm.EVENT_ON_NEW_MESSAGE_SAVE = "NtechApp.ChatMessagesForm.EventOnNewMessageSave";

NtechApp.proto(NtechApp.ChatMessagesForm, {
    isFormOpened: function() {
        return this._$view.hasClass("openedForm");
    },

    _getOpenChatRoute: function() {
        if(NtechApp.clientSettings.isPersonal)
            return 'personal_chats_open_chat';
        else if(NtechApp.clientSettings.isBusiness)
            return 'business_chats_open_chat';
    },

    openChat: function(opponentAccountId) {
        var me = this;
        var params = {opponentAccountId: opponentAccountId};

        this.hideNoMessagesForm();
        this._messagesList.loaderOn();
        this._openChatWindow();

        this._ajax.get({
            url: Routing.generate(me._getOpenChatRoute(), params),
            onSuccess: function(data) {
                me._messagesList.loaderOff();
                me.openForm(data.chatId);
            }
        });
    },

    openForm: function(chatId, silentLoad) {
        var onlyLoad = silentLoad || false;

        this.hideNoMessagesForm();
        this._loadChatMessages(chatId);

        if(onlyLoad)
            return;

        this._openChatWindow();
    },

    closeForm: function() {
        this._$view.removeClass("openedForm");

        var me = this;
        this._closeFormTimeout = setTimeout(function() {
            me._$view.addClass("hiddenForm");
        }, 400);
    },

    _loadChatMessages: function(chatId) {
        if(chatId != this._openedChatId)
            this._messagesList.loadChatMessages(chatId);

        this._openedChatId = chatId;
        NtechApp.currentChatIdForFixtures = this._openedChatId;
    },

    _openChatWindow: function() {
        clearTimeout(this._closeFormTimeout);
        this._$view.removeClass("hiddenForm").addClass("openedForm");
    },

    getOpenedChatId: function() {
        return this._openedChatId;
    },

    hasOpenedChat: function() {
        return this._openedChatId != null;
    },

    emitOnNewMessageCreateEvent: function() {
        $(this).trigger(NtechApp.ChatMessagesForm.EVENT_ON_NEW_MESSAGE_CREATE, [this._openedChatId]);
    },

    emitOnNewMessageSaveEvent: function(chatId, message, messageDate) {
        $(this).trigger(NtechApp.ChatMessagesForm.EVENT_ON_NEW_MESSAGE_SAVE, [
            chatId, message, messageDate
        ]);
    },

    showNoMessagesForm: function() {
        this._$view.find("[data-messagesNoItems]").removeClass("hidden");
        this._$view.find("[data-formMessagesGrid]").addClass("hidden");
    },

    hideNoMessagesForm: function() {
        this._$view.find("[data-messagesNoItems]").addClass("hidden");
        this._$view.find("[data-formMessagesGrid]").removeClass("hidden");
    },

    shouldPullNewChatMessages: function() {
        if(!this.hasOpenedChat())
            return false;

        return true;
    }
});